"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Divider;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledDivider = require("./StyledDivider");
var _excluded = ["type", "orientation", "className", "children", "dashed"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function Divider(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'horizontal' : _ref$type,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? '' : _ref$orientation,
    className = _ref.className,
    children = _ref.children,
    dashed = _ref.dashed,
    restProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
    return /*#__PURE__*/React.createElement(_StyledDivider.StyledDivider, (0, _extends2.default)({
      $type: type,
      $orientation: orientation,
      dashed: !!dashed,
      withText: !!children,
      className: className,
      children: !!children,
      theme: theme
    }, restProps), children && /*#__PURE__*/React.createElement("span", {
      className: "inner"
    }, children));
  });
}
Divider.propTypes = {
  /**
   * Additional CSS ui classes
   */
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  prefixCls: _propTypes.default.string,
  type: _propTypes.default.string,
  orientation: _propTypes.default.oneOf(['left', 'right', '']),
  dashed: _propTypes.default.bool
};
Divider.defaultProps = {
  className: '',
  type: 'horizontal',
  orientation: '',
  dashed: false
};